import {initWebComponent} from "@/helpers/web-component-helper";
import {WizardBodyComponent} from "@/components/wizard/wizard-body-component";
import {setInfoValue} from "@/helpers/info-overview-helper";
import {postWfst} from "@/http/services/http-services-wfst";
import {getGeometryByLayerName, getLayerByName} from "@/helpers/ol-layer-helper";
import {getDefaultName} from "@/helpers/geo-json-helper";
import {Point} from "ol/geom";
import {WKT} from "ol/format";

const template = document.createElement('template');

export class WizardSendMessageComponent extends HTMLElement {
    constructor() {
        super();

        template.innerHTML = `
          <div class="container-fluid d-flex text-white align-items-center card-highlighted-datasets-read-more" style="min-height: calc(100vh - 226px);">
            <div class="row align-items-md-center w-100 py-5">
              <div class="col-12 order-2 order-md-1 text-center">
                <div class="text-large font-weight-bolder mb-5 " style="margin-left:37px">
                    <div class="fa-5x lnr lnr-checkmark-circle text-center text-success mb-5"></div>
                    Uw melding is verstuurd en wordt door ons verwerkt.
                </div>
                <div class="text-big mb-5" style="margin-left:37px">
                  <button class="btn text-transform-none btn-white">Klik hier om nog een melding te maken</button>
                </div>
              </div>
            </div>
          </div>
        `

        initWebComponent(this, template)

        this.querySelector('button').addEventListener('click', () => {
            document.querySelector('wizard-send-message').classList.add('d-none')
            document.querySelector('wizard-nav').classList.remove('d-none')
            document.querySelector('wizard-tab').classList.remove('d-none')
        })
    }
}
